// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-pdf[data-v-07424a76] {\n  height: 500px;\n  overflow-y: auto;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
